import { Typography } from '@mui/material';
import Box from '@mui/material/Box';
import { GenerationModelDetails } from '~/domain/dicom/dicomBase';
import { describeGenerationModel } from '~/utils/transforms/predictionModelsDataTransforms';

type ModelDetailsProps = {
    generationModel?: GenerationModelDetails;
    fullWidth?: boolean;
};

export default function ModelDetails({
    generationModel,
    fullWidth,
}: ModelDetailsProps) {
    const description = describeGenerationModel(generationModel);
    if (!description) {
        return null;
    }
    const { generated: generatedLabel, model: modelLabel } = description;

    return (
        <Box
            display="grid"
            gridTemplateColumns="1fr auto"
            justifyContent="space-between"
            alignItems="center"
            gap={1}
            width={fullWidth ? '100%' : 'auto'}
            overflow="hidden"
        >
            <Typography
                fontSize={10}
                color="text.secondary"
                whiteSpace="nowrap"
                flexShrink={0}
            >
                {generatedLabel}
            </Typography>
            <Typography
                fontSize={10}
                color="text.secondary"
                noWrap
                title={modelLabel}
            >
                {modelLabel}
            </Typography>
        </Box>
    );
}
